import React from "react";
import { Link } from "react-router-dom";
import { GraduationCap, Award, Briefcase, BookOpen, Trophy, ArrowLeft } from "lucide-react";
import { DOCTOR } from "../data/content";
import SEO from "../components/SEO";

const ITEMS = [
  {
    icon: GraduationCap,
    title: "Formación académica",
    items: [
      "Médico Cirujano por la Universidad Veracruzana, México",
      "Especializado en Psiquiatría General por el Hospital de Salud Mental Dr. Miguel Dorantes Mesa, Servicios de Salud de Veracruz",
      "Licenciado en Artes Plásticas por la Universidad Veracruzana. 2do lugar Nacional en Artes Gráficas por el INBA en 1978",
    ],
  },
  {
    icon: Briefcase,
    title: "Experiencia profesional",
    items: [
      "Co-fundador del Hospital de Salud Mental Dr. Miguel Dorantes Mesa en 1979",
      "Médico Especialista en Psiquiatría con 28+ años en el Hospital de Salud Mental, Hospital Dr. Miguel Dorantes Mesa",
      "Médico Especialista en Psiquiatría Adscrito y de Base del Hospital de Salud Mental",
      "Coordinador Médico de la Jornada Acumulada del Hospital de Salud Mental Dr. Miguel Dorantes Mesa",
      "40 años de experiencia en Psiquiatría Hospitalaria a nivel Institucional",
      "19 años de experiencia en Psiquiatría Hospitalaria a nivel Privado",
    ],
  },
  {
    icon: BookOpen,
    title: "Diplomados y especializaciones",
    items: [
      "Diplomado y Especialista en el Tratamiento Integral del Alcoholismo y las Fármaco Dependencias (UV, IIP-UV, CARE Xalapa)",
      "Diplomado en Psicoterapia Gestalt (Escuela Estudios Gestalticos, Gobierno de Veracruz)",
      "Diplomado en Psicoterapias Cognoscitivistas, Breves y de Apoyo (Instituto de Investigaciones Psicológicas - UV)",
      "Diplomado en Tanatología (UV y Centro Estatal de Cancerología CECAN)",
      "Entrenado en Técnicas Psicodramáticas (Clínica Carl Jung, Xalapa)",
    ],
  },
  {
    icon: Award,
    title: "Afiliaciones y certificaciones",
    items: [
      "Afiliado a la Asociación Psiquiátrica Mexicana (APM) A.C.",
      "Certificaciones vigentes para el ejercicio profesional de la psiquiatría en México",
    ],
  },
];

export default function Curriculum() {
  return (
    <div className="max-w-5xl mx-auto px-4 py-12 md:py-16">
      <SEO
        title="Currículum — Dr. César S. Martínez Maldonado"
        description="Formación académica, trayectoria y certificaciones del Dr. César S. Martínez Maldonado. Psiquiatra con más de 40 años de experiencia en Xalapa, Veracruz."
        canonical="/curriculum"
      />
      <Link to="/" className="inline-flex items-center gap-2 text-slate-500 hover:text-cyan-700 transition mb-8 text-sm">
        <ArrowLeft size={16} /> Volver al inicio
      </Link>

      <div className="text-center mb-12">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-cyan-50 text-cyan-700 text-sm font-medium mb-4">
          <Trophy size={16} /> Curriculum Vitae
        </div>
        <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
          {DOCTOR.name}
        </h1>
        <p className="text-xl text-slate-600">Médico Especialista en Psiquiatría y Neurología</p>
      </div>

      <div className="grid md:grid-cols-3 gap-6 mb-12">
        <div className="bg-gradient-to-br from-cyan-500 to-teal-600 text-white rounded-2xl p-6 shadow-lg">
          <div className="text-4xl font-bold">40+</div>
          <div className="text-cyan-50 text-sm mt-1">Años de experiencia en psiquiatría</div>
        </div>
        <div className="bg-gradient-to-br from-emerald-500 to-teal-600 text-white rounded-2xl p-6 shadow-lg">
          <div className="text-4xl font-bold">28+</div>
          <div className="text-emerald-50 text-sm mt-1">Años en Hospital de Salud Mental</div>
        </div>
        <div className="bg-gradient-to-br from-slate-700 to-slate-900 text-white rounded-2xl p-6 shadow-lg">
          <div className="text-4xl font-bold">5</div>
          <div className="text-slate-200 text-sm mt-1">Diplomados de especialización</div>
        </div>
      </div>

      <div className="space-y-8">
        {ITEMS.map(({ icon: Icon, title, items }) => (
          <div key={title} className="bg-white rounded-2xl p-7 border border-slate-100 shadow-sm">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-cyan-100 to-teal-100 flex items-center justify-center">
                <Icon className="text-cyan-700" size={22} />
              </div>
              <h2 className="text-2xl font-bold text-slate-900">{title}</h2>
            </div>
            <ul className="space-y-3">
              {items.map((it, i) => (
                <li key={i} className="flex items-start gap-3 text-slate-700 leading-relaxed">
                  <span className="w-1.5 h-1.5 rounded-full bg-cyan-600 mt-2.5 flex-shrink-0" />
                  <span>{it}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="mt-12 bg-gradient-to-r from-cyan-600 to-teal-600 rounded-2xl p-8 text-white text-center">
        <h3 className="text-2xl font-bold mb-3">¿Listo para iniciar tu tratamiento?</h3>
        <p className="text-cyan-50 mb-6">Agenda una consulta personalizada con el Dr. César</p>
        <Link to="/contacto" className="inline-block px-6 py-3 rounded-full bg-white text-cyan-700 font-semibold hover:scale-105 transition-all">
          Agendar consulta
        </Link>
      </div>
    </div>
  );
}
